import {
  IS_BRIDGE_TO_MEDICARE,
  IS_DENTAL_AND_VISION,
  IS_FIXED_BENEFIT_MEDICAL,
  IS_MEDICARE_SUPPLEMENT,
  MULTI_CARRIER_ENABLED
} from 'core/constants/environment'
import { BTM, DENTAL_STAND_ALONE, FIXED, LATITUDE } from 'core/constants/products'
import isEmpty from 'utils/object/isEmpty'
import isAgentLogged from 'utils/pivot/agent/isAgentLogged'
import getPagePath from './getPagePath'
import store from 'utils/store/withMiddleware'

import { IS_SHORT_TERM } from 'core/constants/environment'

export interface Product {
  name: string
  link: string
  text: string
  isActive: boolean
  hasCoverage?: boolean
  tag?: string
}

/**
 * Responds with a boolean value indicating if there is coverage or not, returns `undefined` if an invalid coverage response was provided.
 * @param coverageResponse The coverage response
 * @param key The product key, undefined will return the `data.coverage` property
 */
function getHasCoverage(coverageResponse: any, key?: number): boolean | undefined {
  if (coverageResponse === undefined) return undefined
  const { error, data } = coverageResponse
  if (error) return undefined

  if (key === undefined) {
    return !isEmpty(data.coverage)
  }
  return data.countByProduct[key] !== undefined
}

export function getProductsWithCoverageFlag(coverageResponse): Product[] {
  const pagePath = getPagePath()

  const dentalVisionProduct: Product = {
    name: 'dental',
    link: `/product/dental-and-vision${pagePath}`,
    text: 'Dental and Vision',
    isActive: IS_DENTAL_AND_VISION,
    hasCoverage: getHasCoverage(coverageResponse, DENTAL_STAND_ALONE)
  }

  const defaultSTMProduct: Product = {
    name: 'stm',
    link: `/product/short-term-health-insurance${pagePath}`,
    text: 'Short Term',
    isActive: IS_SHORT_TERM,
    hasCoverage: getHasCoverage(coverageResponse)
  }

  const searchParams = new URLSearchParams(window.location.search)
  const monthsValue = searchParams.get('months')
  const maxDuration = searchParams.get('maxDuration')

  const stm4MonthProduct: Product = {
    name: 'stm-4',
    link: `/product/short-term-health-insurance${pagePath}?months=4&maxDuration=${maxDuration}`,
    text: 'Short Term - Up to 4 Months',
    isActive: (IS_SHORT_TERM && monthsValue === '4') || !monthsValue,
    hasCoverage: getHasCoverage(coverageResponse)
  }

  const stmLargerMonthProduct: Product = {
    name: 'stm-multi',
    link: `/product/short-term-health-insurance${pagePath}?months=${maxDuration}&maxDuration=${maxDuration}`,
    text: `Short Term - Up to ${maxDuration} Months`,
    isActive: IS_SHORT_TERM && monthsValue !== '4',
    hasCoverage: getHasCoverage(coverageResponse)
  }

  if (!MULTI_CARRIER_ENABLED) return [defaultSTMProduct, dentalVisionProduct]
  else {
    if (window.location.pathname.includes('quotes') && parseInt(maxDuration) > 4) {
      return [stm4MonthProduct, stmLargerMonthProduct, dentalVisionProduct]
    } else if (
      window.location.pathname.includes('quotes') &&
      parseInt(maxDuration) === 4
    ) {
      return [stm4MonthProduct, dentalVisionProduct]
    } else return [defaultSTMProduct, dentalVisionProduct]
  }
}

export default getProductsWithCoverageFlag
